module.exports = __webpack_public_path__ + "static/media/orange-stories-video-001.a02ef6f8.mp4";